export default {

    LOAD_PRODUCT(state, product) {
        state.items = product;
    }

}